export default __webpack_public_path__ + "locales/lv/HotkeysPanel.json?hash=52ed1117a18b9c07cf1e2dea5ac0ffc1";